import React from "react";
import { es } from "@/locales/es";

/**
 * Spanish mirror of ScreenplayPattern.jsx — same decorative, non-legible
 * (~12% opacity, aria-hidden) screenplay-format background texture, text
 * content swapped for the Spanish opening-strip copy. The Spanish line
 * counts match the English tile exactly (3 action1 lines, 4 dialogue1
 * lines, etc.), so this reuses the ENGLISH tile's x/y layout rather than
 * the French 4-line variant.
 */
export const ScreenplayPatternES = ({ className = "" }) => {
  const s = es.openingStrip;
  return (
    <svg
      viewBox="0 0 600 760"
      preserveAspectRatio="xMidYMin slice"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
      data-testid="screenplay-pattern-es"
    >
      <defs>
        <pattern id="vs-screenplay-tile-es" x="0" y="0" width="600" height="760" patternUnits="userSpaceOnUse">
          <g
            fontFamily="'Courier Prime', 'Source Code Pro', 'Inter', monospace"
            fontSize="13"
            fill="#E8E4D6"
            opacity="0.12"
          >
            {/* SLUG LINE 1 */}
            <text x="60" y="40" fontWeight="600" letterSpacing="0.06em">{s.slug1}</text>

            {/* Action — 3 lines */}
            <text x="60" y="78">{s.action1[0]}</text>
            <text x="60" y="96">{s.action1[1]}</text>
            <text x="60" y="114">{s.action1[2]}</text>

            {/* Character cue + parenthetical */}
            <text x="270" y="158" fontWeight="600" letterSpacing="0.04em">{s.cue1}</text>
            <text x="230" y="176" fontStyle="italic" opacity="0.85">{s.paren1}</text>

            {/* Dialogue — 4 lines */}
            <text x="180" y="200">{s.dialogue1[0]}</text>
            <text x="180" y="218">{s.dialogue1[1]}</text>
            <text x="180" y="236">{s.dialogue1[2]}</text>
            <text x="180" y="254">{s.dialogue1[3]}</text>

            {/* SLUG LINE 2 */}
            <text x="60" y="304" fontWeight="600" letterSpacing="0.06em">{s.slug2}</text>

            <text x="60" y="342">{s.action2[0]}</text>
            <text x="60" y="360">{s.action2[1]}</text>
            <text x="60" y="378">{s.action2[2]}</text>

            <text x="270" y="422" fontWeight="600" letterSpacing="0.04em">{s.cue2}</text>

            <text x="180" y="446">{s.dialogue2[0]}</text>
            <text x="180" y="464">{s.dialogue2[1]}</text>
            <text x="180" y="482">{s.dialogue2[2]}</text>

            {/* SLUG LINE 3 */}
            <text x="60" y="530" fontWeight="600" letterSpacing="0.06em">{s.slug3}</text>

            <text x="60" y="568">{s.action3[0]}</text>
            <text x="60" y="586">{s.action3[1]}</text>

            <text x="270" y="630" fontWeight="600" letterSpacing="0.04em">{s.cue3}</text>
            <text x="240" y="648" fontStyle="italic" opacity="0.85">{s.paren3}</text>

            <text x="180" y="672">{s.dialogue3[0]}</text>

            {/* Page number */}
            <text x="540" y="730" fontFamily="'Inter', sans-serif" fontSize="11" opacity="0.6">{s.pageNumber}</text>
          </g>

          <line x1="40" y1="20" x2="40" y2="740" stroke="#C9A961" strokeWidth="0.5" opacity="0.18" />
        </pattern>

        <radialGradient id="vs-vignette-es" cx="50%" cy="50%" r="68%">
          <stop offset="0%"   stopColor="#161117" stopOpacity="0.70" />
          <stop offset="55%"  stopColor="#161117" stopOpacity="0.35" />
          <stop offset="100%" stopColor="#161117" stopOpacity="0" />
        </radialGradient>
      </defs>

      <rect width="100%" height="100%" fill="url(#vs-screenplay-tile-es)" />
      <rect width="100%" height="100%" fill="url(#vs-vignette-es)" />
    </svg>
  );
};

export default ScreenplayPatternES;
